import { Pipe, PipeTransform } from '@angular/core';


/**
 * 字符串缩略管道
 *  @example <p>{{str | stringAbbreviation:8}}</p>
 */
@Pipe({
  name: 'stringAbbreviation'
})
export class StringAbbreviationPipe implements PipeTransform {


  //获取当前dom节点
  constructor() { }

  /**
   * 管道的初始化方法
   * 
   */
  transform(value: any,length:number): any {
    if(value) {
      let str = value;
      let s = str;
      if(str.length > length) {
        s = str.substring(0,length)+" ..."
      }
      return s
    }else {
      return value
    }
  }
}
